import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  alignItems: 'center',
  padding: theme.spacing(6),
  backgroundColor: theme.palette.blue10.main,
  borderRadius: '8px',
}));

export const Content = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  gap: theme.spacing(10),

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
}));

export const CTAContainer = styled('div')(({ theme }) => ({
  '& button, & a': {
    width: 'max-content',
    marginLeft: 'auto',

    [theme.breakpoints.down('lg')]: {
      width: '100%',
    },
  },
}));

export const Image = styled('img')`
  width: 100%;
  max-width: 168px;
  object-fit: contain;
`;

export const Text = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle1,

  [theme.breakpoints.down('lg')]: {
    ...theme.typography.subtitle2,
  },
}));
